import * as _ from 'underscore';
import { Messages } from '../../../../codegen/Localize';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { ExtractEncryptionState, IDataSourceInfo } from '../../../../ts/models/IDataSourceInfo';
import { IWorkbookInfo } from '../../../../ts/models/IWorkbookInfo';
import { IExplorableItemTypeInfo, ISpaceTypeInfo } from '../../../../ts/models/resourceInfoParts';
import { ExtractEncryptionMode } from '../../../../ts/resources/Sites';
import { IExtractConvertAction } from '../../../../ts/ServerApi/types/actionNames';
import { IWorkbookActions } from '../../../../ts/ServerApi/types/IWorkbookActions';
import { encryptContent, EncryptionActionType } from '../../../actions/spaces/EncryptContentAction';
import { appStore } from '../../../AppStore';
import { selectContentFromAppState } from '../../../selectors/ContentSelectors';
import { CompositeSessionInfoSelectors, SessionSiteSelectors } from '../../../selectors/SessionInfoSelectors';
import { selectSpaceInfo, selectSpaceInfoItem } from '../../../selectors/SpaceInfoSelectors';
import { AppState } from '../../../state/AppState';
import { isWorkbookSpace, SpaceInfo } from '../../../state/SpaceInfo';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import {
  isAnyDatasoursEncrypted,
isAnyDatasoursUnencrypted,
  isDatasoursAllLive,
  isEncryptionEnabled,
  isEncryptionEnforced,
  isWorkbookEncryptedExtract,
  isWorkbookUnencryptedExtract } from './IEntityActionHelpers';

export const ExtractsEncryptionEncryptedDsAction: IEntityAction<IWorkbookInfo,  IWorkbookActions> = {
    name: EntityActionNames.ExtractsEncrptionEncrypted,
    translateName: Messages.createExtractsForDsSubActionEncrypted,
    isVisible: (targetItems: IWorkbookInfo[], state: AppState, availableActions: IWorkbookActions) => {
      return isVisibleOnEnabled(state);
    },
    isClickable: (availableActions: IExtractConvertAction, targetItems: IWorkbookInfo[], state: AppState) => {
      return  targetItems[0].extractEncryptionState === ExtractEncryptionState.unencrypted;
    },
    isChecked: (availableActions: IExtractConvertAction, targetItems: IWorkbookInfo[], state: AppState) => {
      return targetItems[0].extractEncryptionState === ExtractEncryptionState.encrypted;
    },
    createReduxAction: (targetItems: IWorkbookInfo[]) => encryptContent(targetItems, EncryptionActionType.encryptExtracts)
};

export const ExtractsEncryptionUnencryptedAction: IEntityAction<IWorkbookInfo, IWorkbookActions> = {
  name: EntityActionNames.ExtractsEncrptionUnencrypted,
  translateName: Messages.createExtractsForDsSubActionUnencrypted,
  isVisible: (targetItems: IWorkbookInfo[], state: AppState, availableActions: IWorkbookActions) => {
    return isVisibleOnEnabled(state);
  },
  isClickable: (availableActions: IWorkbookActions, targetItems: IWorkbookInfo[], state: AppState) => {
    return targetItems[0].extractEncryptionState === ExtractEncryptionState.encrypted;
  },
  isChecked: (availableActions: IWorkbookActions, targetItems: IWorkbookInfo[], state: AppState) => {
    return targetItems[0].extractEncryptionState === ExtractEncryptionState.unencrypted;
  },
  createReduxAction: (targetItems: IWorkbookInfo[]) => encryptContent(targetItems, EncryptionActionType.decryptExtracts)
};

export const ExtractsEncryptionAction: IEntityAction<IWorkbookInfo, IWorkbookActions> = {
  name: EntityActionNames.ExtractsEncrptionAction,
  translateName: (targetItems: IWorkbookInfo[], state: AppState) => {
    if (showEncryptedButtonName(state)) {
      return Messages.extractsEncrptionActionEncrypted();
    } else if (showUnencryptedButtonName(state)) {
      return Messages.extractsEncrptionActionUnencrypted();
    } else {
      return Messages.createExtractForDsAction();
    }
  },
  isVisible: (targetItems: IWorkbookInfo[], state: AppState, availableActions: IWorkbookActions) => {
    return isVisibleOnEnabled(state);
  },
  isClickable: (availableActions: IWorkbookActions, targetItems: IWorkbookInfo[], state: AppState) => {
    return   availableActions && (availableActions.decryptExtracts || availableActions.encryptExtracts);
  },
  isChecked: (availableActions: IWorkbookActions, targetItems: IWorkbookInfo[], state: AppState) => {
    return false;
  },
  createReduxAction: (targetItems: IWorkbookInfo[]) => encryptContent(targetItems,
        SessionSiteSelectors.extractEncryptionMode(appStore.getState()) === ExtractEncryptionMode.ENFORCED
        ? EncryptionActionType.encryptExtracts: EncryptionActionType.decryptExtracts)
};

function isVisibleOnEnabled(state: AppState) {
  const spaceInfo: SpaceInfo = selectSpaceInfo(state);
  return CompositeSessionInfoSelectors.isWebExtractionEnabled(state) && isEncryptionEnabled(state) && isWorkbookSpace(spaceInfo);
}

function showUnencryptedButtonName(state: AppState) {
    // case  workbook has any Unencrypted extract
    const workbook: ISpaceTypeInfo  = selectSpaceInfoItem(state);
    const datasources: ReadonlyArray<IExplorableItemTypeInfo> = selectContentFromAppState(state);
    return isWorkbookUnencryptedExtract(workbook as IWorkbookInfo) ||
    isAnyDatasoursUnencrypted(_.map(datasources, ds =>ds as IDataSourceInfo));
  }

function showEncryptedButtonName(state: AppState) {
    // case  workbook has Encrypted extract
    const workbook: ISpaceTypeInfo  = selectSpaceInfoItem(state);
    const datasources: ReadonlyArray<IExplorableItemTypeInfo> = selectContentFromAppState(state);
    return isEncryptionEnforced(state) || isWorkbookEncryptedExtract(workbook as IWorkbookInfo) ||
     isAnyDatasoursEncrypted(_.map(datasources, ds =>ds as IDataSourceInfo));
  }
